import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { PANDA_I18N_CACHED } from "../../const";
window[PANDA_I18N_CACHED] = _extends({
  PACKID_LIST: [],
  INDEX: 0,
  KEY_MAP: {},
  VK_MAP: new Map()
}, window[PANDA_I18N_CACHED]);
var NUM_HIDDEN = {
  '#': "\u206F",
  '1': "\u202A",
  '2': "\u200E",
  '3': "\u2066",
  '4': "\u2068",
  '5': "\u2061",
  '6': "\u2062",
  '7': "\u2063",
  '8': "\u2064",
  '9': "\u2065",
  '0': "\u206E"
};
function serialize(obj) {
  var fkv = {};
  var fkvs = [];
  ['copyKey', 'packId', 'type', 'componentName', 'isMatched'].forEach(function (key) {
    if (obj[key]) {
      fkv[key] = obj[key];
      fkvs.push(key + ":" + obj[key].toString());
    }
  });
  return [fkv, fkvs.join(';')];
}
export function putCached(VK) {
  var index;
  var _serialize = serialize(VK),
    fvk = _serialize[0],
    fkvkey = _serialize[1];
  if (!window[PANDA_I18N_CACHED].VK_MAP.has(fkvkey)) {
    index = ++window[PANDA_I18N_CACHED].INDEX;
    window[PANDA_I18N_CACHED].VK_MAP.set(fkvkey, index);
    window[PANDA_I18N_CACHED].KEY_MAP[index] = fvk;
  } else {
    index = window[PANDA_I18N_CACHED].VK_MAP.get(fkvkey);
  }
  // convert number to hidden
  return index.toString().split('').map(function (num) {
    return NUM_HIDDEN[num];
  }).join('');
}